module.exports = __webpack_public_path__ + "media/St 4-dishwasher-question.0a8bf72c.wav";